export class ClaimKeys {
  static readonly Upn = 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/upn';
}